<template>
<div class="bg-white px-3 py-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">

  <div class="d-flex align-items-center">
    <!-- <el-button type="success" size="mini" @click="openModel(false)">添加规格</el-button> -->
  
    <div class="mr-auto">
      <el-form inline ref="form" :model="searchform">
        
          <el-form-item  class="mb-0">
             <el-date-picker
                  v-model="searchform.time"
                  type="daterange"
                  range-separator="~"
                 :start-placeholder="$t('searchText.시작')"
                  :end-placeholder="$t('searchText.마감')" size="mini" class="mr-2" value-format="yyyy-MM-dd">
                </el-date-picker>
          </el-form-item>
          <el-form-item class="mb-0 mr-0">
             <el-select v-model="searchform.value" :placeholder="$t('status.선택')" size="mini" style="width:120px;">
               <el-option
                      v-for="item in searchform.searchOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
              </el-select>
          </el-form-item>


          <el-form-item class="mb-0 mr-0">
             <el-input :placeholder="$t('searchText.키워드')" v-model="searchform.keyword" size="mini" style="width:150px" ></el-input>
          </el-form-item>

          <el-form-item class="mb-0 mr-0">
{{$t('msg.하위포함')}}<el-checkbox true-label="1" false-label="0" v-model="searchform.xia" style="margin-left:5px;"></el-checkbox>
          </el-form-item>

          <el-form-item class="mb-0">
            <el-button type="info" size="mini" @click="searchEvent">{{$t('searchText.검색')}}</el-button>  
          </el-form-item>
      </el-form>
    
    </div>

  </div>
 <el-tabs v-model="activeName" @tab-click="handleClick" type="border-card" class="mt-3">
   <el-tab-pane :label="$t('msg.전체')" name="all">
       <el-table
      :data="tableData"
       v-loading="loading"
        show-summary
       :summary-method="getSummaries"
      style="width: 100%"
      border class="mt-2"  :empty-text="$t('tableText.데이타가없습니다')">


       <el-table-column
        
        :label="$t('tableText.날짜')" prop="date" align="center">
        
      </el-table-column>
    
    
        <el-table-column
      
        :label="$t('msg.롤링금')" prop="tt1" align="center">
         <template slot-scope="scope"><span class="text-primary" style="cursor:pointer" @click="rdpModel('roling',scope.row.date)">{{ formatMoney(scope.row.tt1)}}</span></template>
      </el-table-column>

      <el-table-column
       
       :label="$t('msg.롤링금카')" prop="tt1ca" align="center">
         <template slot-scope="scope"><span class="text-primary" style="cursor:pointer" @click="rdpModel('roling_ca',scope.row.date)">{{ formatMoney(scope.row.tt1ca)}}</span></template>
      </el-table-column>

      <el-table-column
        
        :label="$t('msg.롤링금슬')" prop="tt1st" align="center">
         <template slot-scope="scope"><span class="text-primary" style="cursor:pointer" @click="rdpModel('roling_st',scope.row.date)">{{ formatMoney(scope.row.tt1st)}}</span></template>
      </el-table-column>

<template v-if="this.power=='1'">
       <el-table-column

        :label="$t('msg.롤링금파단')" prop="tt1pa" align="center">
         <template slot-scope="scope"><span class="text-primary" style="cursor:pointer" @click="rdpModel('roling_pa',scope.row.date)">{{ formatMoney(scope.row.tt1pa)}}</span></template>
      </el-table-column>

       <el-table-column

        :label="$t('msg.롤링금파조')" prop="tt1pa1" align="center">
         <template slot-scope="scope"><span class="text-primary" style="cursor:pointer" @click="rdpModel('roling_pa',scope.row.date)">{{ formatMoney(scope.row.tt1pa1)}}</span></template>
      </el-table-column>
</template>
      <!--  <el-table-column
        
        :label="$t('nav.루징금')" prop="tt2" align="center">
         <template slot-scope="scope"><span class="text-primary" style="cursor:pointer" @click="rdpModel('rosing',scope.row.date)">{{ formatMoney(scope.row.tt2)}}</span></template>
      </el-table-column>

      <el-table-column
        
          :label="$t('nav.루징금카')" prop="tt2ca" align="center">
         <template slot-scope="scope"><span class="text-primary" style="cursor:pointer" @click="rdpModel('rosing_ca',scope.row.date)">{{ formatMoney(scope.row.tt2ca)}}</span></template>
      </el-table-column>
      <el-table-column
        
         :label="$t('nav.루징금슬')" prop="tt2st" align="center">
         <template slot-scope="scope"><span class="text-primary" style="cursor:pointer" @click="rdpModel('rosing_st',scope.row.date)">{{ formatMoney(scope.row.tt2st)}}</span></template>
      </el-table-column>-->

  
     
    </el-table>
     <div style="height: 100px;"></div>
                      <el-footer class="border-top d-flex align-items-center px-0 position-fixed bg-white" style="bottom: 0;left: 200px;right: 0;z-index: 100;">
                        <div style="flex: 1;" class="px-2">
                          <el-pagination
                          :current-page="currentPage"
                          :page-sizes="[5, 10, 15, 20]"
                          :page-size="size"
                          layout="prev, pager, next"
                          :total="total"
                          @size-change="handleSizeChange"
                              @current-change="handleCurrentChange">
                        </el-pagination>
                        </div>
                      </el-footer>  
    </el-tab-pane>
    <el-tab-pane  :label="$t('msg.회원')" name="first">
       <el-table
      :data="tableData"
       v-loading="loading"
        show-summary
       :summary-method="getSummaries"
      style="width: 100%"
      border class="mt-2"  :empty-text="$t('tableText.데이타가없습니다')">


       <el-table-column
        
        :label="$t('tableText.날짜')" prop="date" align="center">
        
      </el-table-column>
    
    
        <el-table-column
        
        :label="$t('msg.롤링금')" prop="tt1" align="center">
         <template slot-scope="scope"><span class="text-primary" style="cursor:pointer" @click="rdpModel('roling',scope.row.date)">{{ formatMoney(scope.row.tt1)}}</span></template>
      </el-table-column>

      <el-table-column
        
       :label="$t('msg.롤링금카')" prop="tt1ca" align="center">
         <template slot-scope="scope"><span class="text-primary" style="cursor:pointer" @click="rdpModel('roling_ca',scope.row.date)">{{ formatMoney(scope.row.tt1ca)}}</span></template>
      </el-table-column>

      <el-table-column
        
        :label="$t('msg.롤링금슬')" prop="tt1st" align="center">
         <template slot-scope="scope"><span class="text-primary" style="cursor:pointer" @click="rdpModel('roling_st',scope.row.date)">{{ formatMoney(scope.row.tt1st)}}</span></template>
      </el-table-column>

<template v-if="this.power=='1'">
      <el-table-column
        :label="$t('msg.롤링금파단')" prop="tt1pa" align="center">
         <template slot-scope="scope"><span class="text-primary" style="cursor:pointer" @click="rdpModel('roling_pa',scope.row.date)">{{ formatMoney(scope.row.tt1pa)}}</span></template>
      </el-table-column>

       <el-table-column
        :label="$t('msg.롤링금파조')" prop="tt1pa1" align="center">
         <template slot-scope="scope"><span class="text-primary" style="cursor:pointer" @click="rdpModel('roling_pa',scope.row.date)">{{ formatMoney(scope.row.tt1pa1)}}</span></template>
      </el-table-column>
</template>

<template v-if="this.rosing=='1'">
        <el-table-column
       
        :label="$t('nav.루징금')" prop="tt2" align="center">
         <template slot-scope="scope"><span class="text-primary" style="cursor:pointer" @click="rdpModel('rosing',scope.row.date)">{{ formatMoney(scope.row.tt2)}}</span></template>
      </el-table-column>

      <el-table-column
        
          :label="$t('nav.루징금카')" prop="tt2ca" align="center">
         <template slot-scope="scope"><span class="text-primary" style="cursor:pointer" @click="rdpModel('rosing_ca',scope.row.date)">{{ formatMoney(scope.row.tt2ca)}}</span></template>
      </el-table-column>
      <el-table-column
        
         :label="$t('nav.루징금슬')" prop="tt2st" align="center">
         <template slot-scope="scope"><span class="text-primary" style="cursor:pointer" @click="rdpModel('rosing_st',scope.row.date)">{{ formatMoney(scope.row.tt2st)}}</span></template>
      </el-table-column>
</template>
  
     
    </el-table>
     <div style="height: 100px;"></div>
                      <el-footer class="border-top d-flex align-items-center px-0 position-fixed bg-white" style="bottom: 0;left: 200px;right: 0;z-index: 100;">
                        <div style="flex: 1;" class="px-2">
                          <el-pagination
                          :current-page="currentPage"
                          :page-sizes="[5, 10, 15, 20]"
                          :page-size="size"
                          layout="prev, pager, next"
                          :total="total"
                          @size-change="handleSizeChange"
                              @current-change="handleCurrentChange">
                        </el-pagination>
                        </div>
                      </el-footer>  
    </el-tab-pane>
    <el-tab-pane :label="$t('msg.매장')" name="two">
       <el-table
      :data="tableData"
       v-loading="loading"
        show-summary
       :summary-method="getSummaries"
      style="width: 100%"
      border class="mt-2"  :empty-text="$t('tableText.데이타가없습니다')">


       <el-table-column
        
        :label="$t('tableText.날짜')" prop="date" align="center">
        
      </el-table-column>
    
    
        <el-table-column
        
        :label="$t('msg.롤링금')" prop="tt1" align="center">
         <template slot-scope="scope"><span class="text-primary" style="cursor:pointer" @click="rdpModel('roling',scope.row.date)">{{ formatMoney(scope.row.tt1)}}</span></template>
      </el-table-column>
      <el-table-column
        
       :label="$t('msg.롤링금카')" prop="tt1ca" align="center">
         <template slot-scope="scope"><span class="text-primary" style="cursor:pointer" @click="rdpModel('roling_ca',scope.row.date)">{{ formatMoney(scope.row.tt1ca)}}</span></template>
      </el-table-column>

      <el-table-column
        
        :label="$t('msg.롤링금슬')" prop="tt1st" align="center">
         <template slot-scope="scope"><span class="text-primary" style="cursor:pointer" @click="rdpModel('roling_st',scope.row.date)">{{ formatMoney(scope.row.tt1st)}}</span></template>
      </el-table-column>

<template v-if="this.power=='1'">
       <el-table-column
        :label="$t('msg.롤링금파단')" prop="tt1pa" align="center">
         <template slot-scope="scope"><span class="text-primary" style="cursor:pointer" @click="rdpModel('roling_pa',scope.row.date)">{{ formatMoney(scope.row.tt1pa)}}</span></template>
      </el-table-column>

       <el-table-column
        :label="$t('msg.롤링금파조')" prop="tt1pa1" align="center">
         <template slot-scope="scope"><span class="text-primary" style="cursor:pointer" @click="rdpModel('roling_pa',scope.row.date)">{{ formatMoney(scope.row.tt1pa1)}}</span></template>
      </el-table-column>
</template>

<template v-if="this.rosing=='1'">
        <el-table-column
        
        :label="$t('nav.루징금')" prop="tt2" align="center">
         <template slot-scope="scope"><span class="text-primary" style="cursor:pointer" @click="rdpModel('rosing',scope.row.date)">{{ formatMoney(scope.row.tt2)}}</span></template>
      </el-table-column>

 <el-table-column
        
          :label="$t('nav.루징금카')" prop="tt2ca" align="center">
         <template slot-scope="scope"><span class="text-primary" style="cursor:pointer" @click="rdpModel('rosing_ca',scope.row.date)">{{ formatMoney(scope.row.tt2ca)}}</span></template>
      </el-table-column>
      <el-table-column
        
         :label="$t('nav.루징금슬')" prop="tt2st" align="center">
         <template slot-scope="scope"><span class="text-primary" style="cursor:pointer" @click="rdpModel('rosing_st',scope.row.date)">{{ formatMoney(scope.row.tt2st)}}</span></template>
      </el-table-column>
  </template>
     
    </el-table>
     <div style="height: 100px;"></div>
                      <el-footer class="border-top d-flex align-items-center px-0 position-fixed bg-white" style="bottom: 0;left: 200px;right: 0;z-index: 100;">
                        <div style="flex: 1;" class="px-2">
                          <el-pagination
                          :current-page="currentPage"
                          :page-sizes="[5, 10, 15, 20]"
                          :page-size="size"
                          layout="prev, pager, next"
                          :total="total"
                          @size-change="handleSizeChange"
                              @current-change="handleCurrentChange">
                        </el-pagination>
                        </div>
                      </el-footer>  
    </el-tab-pane>
    <el-tab-pane :label="$t('msg.총판')" name="three">
       <el-table
      :data="tableData"
       v-loading="loading"
        show-summary
       :summary-method="getSummaries"
      style="width: 100%"
      border class="mt-2"  :empty-text="$t('tableText.데이타가없습니다')">


       <el-table-column
        
        :label="$t('tableText.날짜')" prop="date" align="center">
        
      </el-table-column>
    
    
        <el-table-column
        
        :label="$t('msg.롤링금')" prop="tt1" align="center">
         <template slot-scope="scope"><span class="text-primary" style="cursor:pointer" @click="rdpModel('roling',scope.row.date)">{{ formatMoney(scope.row.tt1)}}</span></template>
      </el-table-column>
<el-table-column
        
       :label="$t('msg.롤링금카')" prop="tt1ca" align="center">
         <template slot-scope="scope"><span class="text-primary" style="cursor:pointer" @click="rdpModel('roling_ca',scope.row.date)">{{ formatMoney(scope.row.tt1ca)}}</span></template>
      </el-table-column>

      <el-table-column
        
        :label="$t('msg.롤링금슬')" prop="tt1st" align="center">
         <template slot-scope="scope"><span class="text-primary" style="cursor:pointer" @click="rdpModel('roling_st',scope.row.date)">{{ formatMoney(scope.row.tt1st)}}</span></template>
      </el-table-column>


<template v-if="this.power=='1'">
       <el-table-column
        :label="$t('msg.롤링금파단')" prop="tt1pa" align="center">
         <template slot-scope="scope"><span class="text-primary" style="cursor:pointer" @click="rdpModel('roling_pa',scope.row.date)">{{ formatMoney(scope.row.tt1pa)}}</span></template>
      </el-table-column>

       <el-table-column
        :label="$t('msg.롤링금파조')" prop="tt1pa1" align="center">
         <template slot-scope="scope"><span class="text-primary" style="cursor:pointer" @click="rdpModel('roling_pa',scope.row.date)">{{ formatMoney(scope.row.tt1pa1)}}</span></template>
      </el-table-column>
</template>

<template v-if="this.rosing=='1'">

        <el-table-column
        
        :label="$t('nav.루징금')" prop="tt2" align="center">
         <template slot-scope="scope"><span class="text-primary" style="cursor:pointer" @click="rdpModel('rosing',scope.row.date)">{{ formatMoney(scope.row.tt2)}}</span></template>
      </el-table-column>
      <el-table-column
        
          :label="$t('nav.루징금카')" prop="tt2ca" align="center">
         <template slot-scope="scope"><span class="text-primary" style="cursor:pointer" @click="rdpModel('rosing_ca',scope.row.date)">{{ formatMoney(scope.row.tt2ca)}}</span></template>
      </el-table-column>
      <el-table-column
        
         :label="$t('nav.루징금슬')" prop="tt2st" align="center">
         <template slot-scope="scope"><span class="text-primary" style="cursor:pointer" @click="rdpModel('rosing_st',scope.row.date)">{{ formatMoney(scope.row.tt2st)}}</span></template>
      </el-table-column>
  </template>
     
    </el-table>
     <div style="height: 100px;"></div>
                      <el-footer class="border-top d-flex align-items-center px-0 position-fixed bg-white" style="bottom: 0;left: 200px;right: 0;z-index: 100;">
                        <div style="flex: 1;" class="px-2">
                          <el-pagination
                          :current-page="currentPage"
                          :page-sizes="[5, 10, 15, 20]"
                          :page-size="size"
                          layout="prev, pager, next"
                          :total="total"
                          @size-change="handleSizeChange"
                              @current-change="handleCurrentChange">
                        </el-pagination>
                        </div>
                      </el-footer>  
    </el-tab-pane>
    <el-tab-pane :label="$t('msg.부본사')"label="" name="four">
       <el-table
      :data="tableData"
       v-loading="loading"
        show-summary
       :summary-method="getSummaries"
      style="width: 100%"
      border class="mt-2"  :empty-text="$t('tableText.데이타가없습니다')">


       <el-table-column
        
        :label="$t('tableText.날짜')" prop="date" align="center">
        
      </el-table-column>
    
    
        <el-table-column
        
        :label="$t('msg.롤링금')" prop="tt1" align="center">
         <template slot-scope="scope"><span class="text-primary" style="cursor:pointer" @click="rdpModel('roling',scope.row.date)">{{ formatMoney(scope.row.tt1)}}</span></template>
      </el-table-column>
      <el-table-column
        
       :label="$t('msg.롤링금카')" prop="tt1ca" align="center">
         <template slot-scope="scope"><span class="text-primary" style="cursor:pointer" @click="rdpModel('roling_ca',scope.row.date)">{{ formatMoney(scope.row.tt1ca)}}</span></template>
      </el-table-column>

      <el-table-column
        
        :label="$t('msg.롤링금슬')" prop="tt1st" align="center">
         <template slot-scope="scope"><span class="text-primary" style="cursor:pointer" @click="rdpModel('roling_st',scope.row.date)">{{ formatMoney(scope.row.tt1st)}}</span></template>
      </el-table-column>

<template v-if="this.power=='1'">
       <el-table-column
        :label="$t('msg.롤링금파단')" prop="tt1pa" align="center">
         <template slot-scope="scope"><span class="text-primary" style="cursor:pointer" @click="rdpModel('roling_pa',scope.row.date)">{{ formatMoney(scope.row.tt1pa)}}</span></template>
      </el-table-column>

       <el-table-column
        :label="$t('msg.롤링금파조')" prop="tt1pa1" align="center">
         <template slot-scope="scope"><span class="text-primary" style="cursor:pointer" @click="rdpModel('roling_pa',scope.row.date)">{{ formatMoney(scope.row.tt1pa1)}}</span></template>
      </el-table-column>
</template>


<template v-if="this.rosing=='1'">
        <el-table-column
        
        :label="$t('nav.루징금')" prop="tt2" align="center">
         <template slot-scope="scope"><span class="text-primary" style="cursor:pointer" @click="rdpModel('rosing',scope.row.date)">{{ formatMoney(scope.row.tt2)}}</span></template>
      </el-table-column>

    
 <el-table-column
        
          :label="$t('nav.루징금카')" prop="tt2ca" align="center">
         <template slot-scope="scope"><span class="text-primary" style="cursor:pointer" @click="rdpModel('rosing_ca',scope.row.date)">{{ formatMoney(scope.row.tt2ca)}}</span></template>
      </el-table-column>
      <el-table-column
        
         :label="$t('nav.루징금슬')" prop="tt2st" align="center">
         <template slot-scope="scope"><span class="text-primary" style="cursor:pointer" @click="rdpModel('rosing_st',scope.row.date)">{{ formatMoney(scope.row.tt2st)}}</span></template>
      </el-table-column>
    </template>
     
    </el-table>
     <div style="height: 100px;"></div>
                      <el-footer class="border-top d-flex align-items-center px-0 position-fixed bg-white" style="bottom: 0;left: 200px;right: 0;z-index: 100;">
                        <div style="flex: 1;" class="px-2">
                          <el-pagination
                          :current-page="currentPage"
                          :page-sizes="[5, 10, 15, 20]"
                          :page-size="size"
                          layout="prev, pager, next"
                          :total="total"
                          @size-change="handleSizeChange"
                              @current-change="handleCurrentChange">
                        </el-pagination>
                        </div>
                      </el-footer>  
    </el-tab-pane>
  </el-tabs>
  <el-dialog
            :visible.sync="rdpDialog" :width="rdpw" class="rdp" :title="rdpTitle" :close-on-click-modal ="false">
            <div class="border-bottom py-3"><span class="text-danger"></span></div>
            <el-table
                :data="rdpIdData"
                style="width: 100%" v-loading="loading"  
                show-summary 
                :summary-method="getSummariesM">
                <el-table-column
                  prop="mem_id"
                  :label="$t('nav.아이디')" align="center">
                </el-table-column>

                <el-table-column
                  prop="mem_name"
                  :label="$t('msg.닉네임')" align="center">
                </el-table-column>

                <el-table-column
                  prop="tt678"
                  :label="$t('msg.롤링')"
                  align="center">
                  <template slot-scope="scope">
                     <span class="text-primary" @click="moenyModel(scope,'')">{{formatMoney(scope.row.tt678)}}</span>
                  </template>
                </el-table-column>

                <el-table-column
                  prop="tt7"
                  :label="$t('msg.롤링카')"
                   align="center">
                  <template slot-scope="scope">
                     <span class="text-primary" @click="moenyModel(scope,'2')">{{formatMoney(scope.row.tt7)}}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="tt6"
                   :label="$t('msg.롤링슬')"
                   align="center">
                  <template slot-scope="scope">
                     <span class="text-primary" @click="moenyModel(scope,'1')">{{formatMoney(scope.row.tt6)}}</span>
                  </template>
                </el-table-column>

<template v-if="this.power=='1'">
                <el-table-column
                  prop="tt8"
                  :label="$t('msg.롤링파단')"
                   align="center">
                  <template slot-scope="scope">
                     <span class="text-primary" @click="moenyModel(scope,'3')">{{formatMoney(scope.row.tt8)}}</span>
                  </template>
                </el-table-column>

                 <el-table-column
                  prop="tt88"
                  :label="$t('msg.롤링파조')"
                  align="center">
                  <template slot-scope="scope">
                     <span class="text-primary" @click="moenyModel(scope,'4')">{{formatMoney(scope.row.tt88)}}</span>
                  </template>
                </el-table-column>
</template>
                 <el-table-column
                  prop="type"
                   :label="$t('tableText.타입')"
                 align="center">
                  <template slot-scope="scope">
                  {{typeObj[scope.row.type]}}
                  </template>
                </el-table-column>



                 <el-table-column
                  prop="a_code"
                  :label="$t('tableText.부본사총판매장')"
                   align="center" width="200">
                   <template slot-scope="scope">
                  {{ scope.row.a_code}}-{{ scope.row.b_code}}-{{ scope.row.c_code}}
                  </template>
                </el-table-column>
                
              

                 
                
              
              </el-table>
  
            <span slot="footer" class="dialog-footer">
              <el-button @click="rdpDialog = false">Close</el-button>
        
            </span>
          </el-dialog>
 <el-dialog
            :visible.sync="MonDialog" :width="rdpw" class="rdp" :close-on-click-modal ="false">
           
            <el-table
                :data="moneyData"
                style="width: 100%" v-loading="monLoading">
                <el-table-column
                  prop="mem_id"
                  :label="$t('nav.아이디')" align="center">
                </el-table-column>

                <el-table-column
                  prop="money"
                  :label="$t('tableText.금액')"
                  align="center">
                </el-table-column>
                <el-table-column
                  prop="doc"
                  :label="$t('msg.내용')"
                  align="center">

                </el-table-column>

                <el-table-column
                  prop="add_time"
                  :label="$t('tableText.시간')"
                  align="center">
                </el-table-column>
    
              </el-table>
             <div style="height: 10px;"></div>
                      <el-footer class="d-flex align-items-center px-0  bg-white">
                        <div style="flex: 1;" class="px-2">
                          <el-pagination
                          :current-page="mcurrentPage"
                          :page-sizes="[5, 10, 15, 20]"
                          :page-size="msize"
                          layout="prev, pager, next"
                          :total="mtotal"
                          @size-change="mhandleSizeChange"
                              @current-change="mhandleCurrentChange">
                        </el-pagination>
                        </div>
                      </el-footer> 
            <span slot="footer" class="dialog-footer">
              <el-button @click="MonDialog = false">Close</el-button>
        
            </span>
          </el-dialog>
    
        
        
</div>
 </template>

 <script>
 
    export default {
      
      data(){
        return{
          xia:false,
          gametype:'',
          rows:null,
          moneyData:[],
          monLoading:false,
          MonDialog:false,
          rdpTitle:'',
          rdpw:'870px',
          rdpIdData:[],
          user_type:'',
          type:'',
          rdpDialog:false,
          activeName: 'all',
          tapidx:"0",
          domain:window.sessionStorage.getItem('domain'),
           power:window.sessionStorage.getItem('power'),
             rosing:window.sessionStorage.getItem('rosing'),
            qa:[],
             colorObj:{
              '0':'text-danger',
              '1':'text-primary',
              '2':'text-success',
             
             
            },
            valObj:{
              '0':this.$i18n.t("msg.대기"),
              '1':this.$i18n.t("msg.블랙"),
              '2':this.$i18n.t("msg.보류"),
            },
              typeObj:{
              
              '1':this.$i18n.t("msg.배팅"), 
               '7':this.$i18n.t("msg.당첨"),
              '2':this.$i18n.t("msg.입금"),
              '3':this.$i18n.t("msg.출금"),
              '4':this.$i18n.t("msg.롤링전환"),
              '5':this.$i18n.t("msg.롤링지급"),
               '12':this.$i18n.t("msg.매장롤링"),
              '6':this.$i18n.t("msg.총판롤링"),
              '8':this.$i18n.t("msg.부본사롤링"),
              '9':this.$i18n.t("msg.회원롤링"),
              '10':this.$i18n.t("msg.알충전"),
              '11':this.$i18n.t("msg.알환전"),

               '13':this.$i18n.t("msg.롤링충전"),
              '14':this.$i18n.t("msg.롤링환전"),
             
              '21':this.$i18n.t("msg.사이트머니카지노머니전환"),
              '22':this.$i18n.t("msg.카지노머니사이트머니전환"),
 
            },
          searchform:{
            keyword:'',
            time:[],
            searchOptions:[
             
             {
             label:this.$i18n.t("msg.아이디"),
              value:'mem_id'
            }
            ],
           
            value:'',
          


          },
           pickerOptions: {
          },
          shortcuts: [{
            text:this.$i18n.t("dateText.최근한주"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text:this.$i18n.t("dateText.최근한달"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text:this.$i18n.t("dateText.최근3개월"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }],
        
          
            
         mtotal:0,
          msize:0,
          total:0,
          size:0,
          loading: false,
           editIndex:-1,
           creatModel:false,
           tableData: [],
           mcurrentPage:1,
                currentPage:1,
                multipleSelection:[],
                mPage:'',
             
               
          }
          
          
        },
        created() {
          

          this.getList();
          
      
    },
      mounted(){
      let this_ = this
      let table=document.querySelector('.el-table__footer-wrapper>table');
      this.$nextTick(()=>{
        table.rows[0].cells[1].onclick = function(){
        this_.totalclick();
        }
  })

},
      methods:{
        totalclick(){
         this.rdpModel('','')
        },
        moenyModel(e,g){
          this.mPage = e
          this.MonDialog = true
          this.monLoading = true
          this.gametype=g
          this.rows=e

           let token=window.sessionStorage.getItem('user');
           let urls=this.domain+'/admin/roling_rosing_date_byid?xia='+this.searchform.xia+'&game_type='+g+'&mem_id='+e.row.mem_id+'&date='+this.rdpTitle+'&type='+this.type+'&page='+this.mcurrentPage;
          this.$axios({
                  method:'get',
                  url:urls,
                  'Accept': 'application/json',
                   headers: { 'Authorization': 'Bearer ' + token },  
            }).then((response) =>{ 
                     this.monLoading =false
                     console.log('mtotal=',response.data.data.total)
                     this.moneyData =response.data.data.data
                     this.mtotal = response.data.data.total
                     this.mcurrentPage = response.data.data.current_page
                     this.msize =response.data.data.per_page
                     
                    
               
            }).catch((error) =>{
              
               this.$message.error(error);
               this.monLoading = false
                //console.log('error',error.response)       //请求失败返回的数据
               
            })
        },
        rdpModel(t,d){
          this.rdpDialog = true
          this.loading = true

               let s_time="";
               let e_time="";

               if(this.searchform.time.length>0)
               {
                  s_time=this.searchform.time[0];
                  e_time=this.searchform.time[1];
               }

          
           let token=window.sessionStorage.getItem('user');
           let urls=this.domain+'/admin/roling_rosing_date_by?xia='+this.searchform.xia+'&gubun='+t+'&s_time='+s_time+'&e_time='+e_time+'&date='+d+'&user_type='+this.user_type+'&type='+this.type+'&'+this.searchform.value+'='+this.searchform.keyword;
          this.$axios({
                  method:'get',
                  url:urls,
                  'Accept': 'application/json',
                   headers: { 'Authorization': 'Bearer ' + token },  
            }).then((response) =>{ 
                     this.loading =false
                     console.log('rdpdata=',response.data.data)
                     this.rdpIdData =response.data.data
                     this.rdpTitle=response.data.s_time+"~"+response.data.e_time
                    
               
            }).catch((error) =>{
              
               this.$message.error(error);
               this.loading = false
                //console.log('error',error.response)       //请求失败返回的数据
               
            })

        },
           handleClick(tab, event) {
              //console.log(tab, event);
              this.tapidx=tab.index
              this.getList(this.tapidx)
      },
          getSummaries(param) {
        const {
          columns,
          data
        } = param;
        const sums = [];
        columns.forEach((column, index) => {
         if (index === 1) { 
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
               sums[index] = this.formatMoney(sums[index],1);
            } else {
              sums[index] = '/';
            }
          }else if (index === 2) { 
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
               sums[index] = this.formatMoney(sums[index],1);
            } else {
              sums[index] = '/';
            }
          }else if (index === 3) { 
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
               sums[index] = this.formatMoney(sums[index],1);
            } else {
              sums[index] = '/';
            }
          }else if (index === 4) { 
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
               sums[index] = this.formatMoney(sums[index],1);
            } else {
              sums[index] = '/';
            }
          }else if (index === 5) { 
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
               sums[index] = this.formatMoney(sums[index],1);
            } else {
              sums[index] = '/';
            }
          }else if (index === 6) { 
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
               sums[index] = this.formatMoney(sums[index],1);
            } else {
              sums[index] = '/';
            }
          }
          else {
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
            } else {
              sums[index] = '/';
            }
          }
        });
        return sums;
      },
    
         getSummariesM(param) {
        const {
          columns,
          data
        } = param;
        const sums = [];
        columns.forEach((column, index) => {
          if (index === 0) { 
              sums[index] = '/'
              return
            }
            else if (index === 1) { 
              sums[index] = '/'
              return
            }
         if (index === 2) { 
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
               sums[index] = this.formatMoney(sums[index],1);
            } else {
              sums[index] = '/';
            }
          }else if (index === 3) { 
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
               sums[index] = this.formatMoney(sums[index],1);
            } else {
              sums[index] = '/';
            }
          }else if (index === 4) { 
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
               sums[index] = this.formatMoney(sums[index],1);
            } else {
              sums[index] = '/';
            }
          }else if (index === 5) { 
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
               sums[index] = this.formatMoney(sums[index],1);
            } else {
              sums[index] = '/';
            }
          }
          else if (index === 6) { 
              const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
               sums[index] = this.formatMoney(sums[index],1);
            } else {
              sums[index] = '/';
            }
            } else if (index === 7) { 
              sums[index] = '/'
              return
            }
        });
        return sums;
      },
       
    
           // 搜索事件
      searchEvent(){

          this.getList(this.tapidx);
          
             

        },
         handleSizeChange(val) {
              //console.log(`每页 ${val} 条`);
              this.size = val
              this.getList(this.tapidx);
              this.loading= true

            },
            handleCurrentChange(val) {
              //console.log(`当前页: ${val}`);
              this.currentPage = val
              this.getList(this.tapidx);
              this.loading= true
            },
         mhandleSizeChange(val) {
              //console.log(`每页 ${val} 条`);
              this.msize = val
              this.moenyModel(this.rows,this.gametype);
              this.monLoading= true

            },
            mhandleCurrentChange(val) {
              //console.log(`当前页: ${val}`);
              this.mcurrentPage = val
              this.moenyModel(this.rows,this.gametype);
              this.monLoading= true
            },  
        getList(v){

               //console.log(v) 
               let s_time="";
               let e_time="";

               if(this.searchform.time.length>0)
               {
                  s_time=this.searchform.time[0];
                  e_time=this.searchform.time[1];
               }

               this.type='';
               this.user_type='';


               if(v=='1')
               {
                 this.type='5';
                 this.user_type='user';

               }
               if(v=='2')
               {
                 this.type='12';
                 this.user_type='pt';
               }
               if(v=='3')
               {
                 this.type='6';
                 this.user_type='pt';
               }
               if(v=='4')
               {
                 this.type='8';
                 this.user_type='pt';
               }

              
          this.loading = true

           let token=window.sessionStorage.getItem('user');
            //console.log(token);
           let urls=this.domain+'/admin/roling_rosing_date?xia='+this.searchform.xia+'&type='+this.type+'&s_time='+s_time+'&e_time='+e_time+'&page='+this.currentPage+'&'+this.searchform.value+'='+this.searchform.keyword
          
    
          this.$axios({
                  method:'get',
                  url:urls,
                  'Accept': 'application/json',
                   headers: { 'Authorization': 'Bearer ' + token },
                
               
            }).then((response) =>{ 


                     console.log('data=',response.data.data)
                     this.tableData =response.data.data
                     this.total = response.data.total
                     this.currentPage = response.data.current_page
                     this.size =response.data.per_page
                     this.loading =false
               
            }).catch((error) =>{
              

               this.$message.error(error);
               this.loading = false
                //console.log('error',error.response)       //请求失败返回的数据
               
            })
        },
        
        
      
      
      
        
      }
  }
</script>

 <style scoped>
 .bg-danger{
  background-color:#72e8ff!important
 }
.bg-primary{
  background-color:#acc4dd!important
}
.bg-yellow {
    background-color: #dc8e35!important;
}
/deep/ .el-select-dropdown__item.selected{
  color:#000
}
/deep/ .el-input__inner{
  background:transparent;
  border:1px solid #cfcfcf;
  border-radius:2px;
}
/deep/ .el-dialog__body{
  padding:10px 20px;
}
/deep/ .el-form-item {
  margin-bottom:10px;
}
 /deep/ .el-form-item__content{
    display:flex;
    align-items:center;
    line-height:30px;
 }

 /deep/ .el-input__inner{
  height:30px;
  line-height:30px;
 }
 /deep/ .el-form-item__label{
  line-height:30px;
 }
>>>.el-dialog__headerbtn{
  z-index: 100;
}

</style>


// WEBPACK FOOTER //
// src/views/rdp/list.vue